import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const service = inject(AuthService);

  if (!service.isAuthenticated()) {
    router.navigate(['/login']);

    return false;
  }

  return true;
};
